<template>
    <div class="page">

        <v-container grid-list-xl>

            <div class="text-center mt-7 mb-7">
                <h2>Kellnerruf erfolgreich</h2>
            </div>

            <div class="indented  text-center">
                <div class="icon icon--order-success svg">
                    <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 72 72">
                        <circle stroke="#50A92F" stroke-width="2" cx="36" cy="36" r="34" fill="none"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" fill="#50A92F"
                              d="M52.5 21.4c-.9-.6-2.1-.5-2.8.2l-20.7 20.2-4.7-5.1c-.8-.8-2.4-1.2-3.5-.5-1.1.9-1.2 2.3-.5 3.5 0 0 5.1 8.7 5.7 9.7s1.6 1.6 3 1.6c1.1 0 2-.6 2.9-1.6.7-.8 20.8-25.3 20.8-25.3.6-.7.6-2-.2-2.7z"></path>
                    </svg>
                    <!--                <svg xmlns="http://www.w3.org/2000/svg" width="90" height="90" viewBox="0 0 72 72">-->
                    <!--                    <g fill="none" stroke="#6de623" stroke-width="2">-->
                    <!--                        <circle cx="36" cy="36" r="35"-->
                    <!--                                style="stroke-dasharray:240px, 240px; stroke-dashoffset: 480px;"></circle>-->
                    <!--                        <path d="M17.417,37.778l9.93,9.909l25.444-25.393"-->
                    <!--                              style="stroke-dasharray:50px, 50px; stroke-dashoffset: 0px;"></path>-->
                    <!--                    </g>-->
                    <!--                </svg>-->
                </div>
                <v-btn class="btn-df okBtn mt-7" @click="ok">OK</v-btn>
            </div>
        </v-container>

    </div>
</template>

<script>
    export default {
        methods:{
            ok(){
                this.$router.replace({name: 'Sortiment'});
            }
        }
    }
</script>

<style lang="scss" scoped>
    /*@import '../styles/sharedStyles';*/

    .icon--order-success svg path {
        -webkit-animation: checkmark 0.25s ease-in-out 0.7s backwards;
        animation: checkmark 0.25s ease-in-out 0.7s backwards
    }

    .icon--order-success svg circle {
        -webkit-animation: checkmark-circle 0.6s ease-in-out backwards;
        animation: checkmark-circle 0.6s ease-in-out backwards
    }

</style>